import { Text } from '@mantine/core';
import { GENDERS, Gender } from '@constants/genderType';
import { capitalizeValue } from '@utils/StringUtils';
import BulletItem from './BulletItem';

interface JobSkillsProps {
  skills: string[];
}

export default function JobSkills({ skills }: JobSkillsProps) {
  if (!skills?.length) {
    return null;
  }

  const genderRequirement = skills.filter((skill) => GENDERS.includes(skill));
  const showGenderRequirement =
    genderRequirement.length === 1 &&
    genderRequirement[0] !== Gender.ANY_GENDER.valueOf();
  const otherSkills = skills.filter((skill) => !GENDERS.includes(skill));

  return (
    <>
      <Text fz={14} fw={700} mt="md">
        Skills and Requirements:
      </Text>
      {otherSkills.map((skill) => (
        <BulletItem key={skill} content={skill} ml={16} />
      ))}
      {showGenderRequirement && (
        <>
          <Text fz={14} fw={700} mt="xs">
            Gender requirement:
          </Text>
          <BulletItem content={capitalizeValue(genderRequirement[0])} ml={16} />
        </>
      )}
    </>
  );
}
